import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "on-focus__predefined-queries-container q-text-dark" }

import {inject} from "vue";
import QueriesContainer from '../Queries/QueriesContainer.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'PredefinedQueriesContainer',
  props: ['sections'],
  setup(__props) {

const props = __props

const SmartSearchConfig = inject('SmartSearchConfig').value;
const {enabled, sections} = SmartSearchConfig.onfocus.predefinedQueries
const showPredefinedQueries = props.sections.length > 0 && enabled


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sections), (section) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "on-focus__predefined-queries-content q-row",
        key: section
      }, [
        (_unref(showPredefinedQueries))
          ? (_openBlock(), _createBlock(QueriesContainer, {
              key: 0,
              queries: section.queries,
              "queries-header": section.header
            }, null, 8, ["queries", "queries-header"]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})